import Vue from "vue";
import axios from 'axios';

Vue.mixin({
  methods: {
    formatContent(stringFormat, ...args) {
      return stringFormat.replace(/\{\{|\}\}|\{(\d+)\}/g, function (
        curlyBracket,
        index
      ) {
        let replaceValue = args[index];
        if (replaceValue == null) {
          replaceValue = ''
        }
        return curlyBracket == "{{"
          ? "{"
          : curlyBracket == "}}"
            ? "}"
            : replaceValue;
      });
    },
    sendEmail({ subject, message, file_urls, recipients, from, cc, bcc, reply, userID, isHtml, type, referenceID, status, countdown }, ...args) {
      if (recipients == null || recipients.length === 0) {
        return;
      }
      recipients = recipients.filter(recipient => recipient !== this.$store.getters.enginehireLoggingEmail);
      const subjectString = this.formatContent(subject, ...args);
      const messageString = this.formatContent(message, ...args);
      // Find reply email
      let replyEmail;;
      if (reply && reply !== "aakash@enginehire.ca") {
        replyEmail = reply;
      } else if (from) {
        replyEmail = from;
      } else {
        replyEmail = this.$store.getters.agencyReplyEmail;
      }
      this.$store.dispatch("sendEmails", {
        subject: subjectString,
        message: messageString,
        file_urls: file_urls,
        from: from ? from : this.$store.getters.agencyFromEmail,
        cc: cc,
        bcc: bcc,
        emails: [...new Set(recipients)],
        reply: replyEmail,
        userID: userID ? userID : this.$store.getters.userID,
        html: isHtml,
        type: type,
        referenceID: referenceID,
        status: status,
        countdown: countdown
      });
    },
    sendEmailSync({ subject, message, file_urls, recipients, from, cc, bcc, reply, userID, isHtml, type, referenceID }, ...args) {
      return new Promise(async (resolve) => {
        if (recipients == null || recipients.length === 0) {
          resolve();
          return;
        }
        recipients = recipients.filter(recipient => recipient !== this.$store.getters.enginehireLoggingEmail);
        const subjectString = this.formatContent(subject, ...args);
        const messageString = this.formatContent(message, ...args);
        // Find reply email
        let replyEmail;;
        if (reply && reply !== "aakash@enginehire.ca") {
          replyEmail = reply;
        } else if (from) {
          replyEmail = from;
        } else {
          replyEmail = this.$store.getters.agencyReplyEmail;
        }
        await this.$store.dispatch("sendEmails", {
          subject: subjectString,
          message: messageString,
          file_urls: file_urls,
          from: from ? from : this.$store.getters.agencyFromEmail,
          cc: cc,
          bcc: bcc,
          emails: [...new Set(recipients)],
          reply: replyEmail,
          userID: userID ? userID : this.$store.getters.userID,
          html: isHtml,
          type: type,
          referenceID: referenceID
        });
        resolve();
      })
    },
    getEmailSenderFromEmailTemplate(emailTemplate) {
      let fromEmail = "";
      if (this.$store.getters.isAgent &&
        emailTemplate.use_current_admin_email &&
        this.$store.getters.userEmail
      ) {
        fromEmail = this.$store.getters.userEmail;
      } else if (emailTemplate.from_email) {
        fromEmail = emailTemplate.from_email;
      } else {
        fromEmail = this.$store.getters.agency.from_email
          ? this.$store.getters.agency.from_email
          : this.$store.getters.agencyFromEmail;
      }
      return fromEmail;
    },
    getReplyToFromEmailTemplate(emailTemplate, emailObj) {
      // Use admin email
      if (emailTemplate && this.$store.getters.isAgent) {
        if (
          emailTemplate.use_current_admin_email &&
          this.$store.getters.userEmail
        ) {
          return this.$store.getters.userEmail;
        }
      }
      // Reply email is specified in the emailObj
      if (emailObj && emailObj.reply) {
        return emailObj.reply;
      }
      // Reply email is specified in the email templace
      if (emailTemplate && emailTemplate.reply_email) {
        return emailTemplate.reply_email;
      }
      // Reply email  = from email if it is not default from email
      let fromEmail;
      if (emailObj && emailObj.from) {
        fromEmail = emailObj.from
      } else if (emailTemplate) {
        fromEmail = this.getEmailSenderFromEmailTemplate(emailTemplate);
      }
      if (fromEmail && fromEmail !== this.$store.getters.agencyFromEmail) {
        return fromEmail;
      }
      const agencyReplyEmail = this.$store.getters.agencyReplyEmail;
      if (agencyReplyEmail && agencyReplyEmail !== "aakash@enginehire.ca") {
        return agencyReplyEmail;
      }
      return this.$store.getters.agencyFromEmail;
    },
    sendBackgroundEmailToEnginehire(subject, message, recipients = ["aakash@enginehire.ca", "mary@enginehire.ca"]) {
      this.$store.dispatch("sendEmails", {
        subject: subject,
        message: message,
        from: "agency@enginehire.io",
        emails: recipients,
        reply: "agency@enginehire.io",
        html: true,
        in_background: true,
        userID: 4
      });
    },
  }
});



// WEBPACK FOOTER //
// ./src/mixins/email-handling.js